// React Hooks:
import React, { useState, useEffect } from "react";
// Redux Toolkit Hooks:
import { useAppSelector, useAppDispatch } from "../../../../../../app/hooks";
// Redux Toolkit Actions & State:
import {
  drawerShare,
  shareFileAction,
  resetShareFileStatusAction,
} from "./drawerShareSlice";
import {
  alternativeFileModalAction,
  deleteSelectedAlternativeFileAction,
  alternativeFileModal,
} from "./alternative-file-modal/alternativeFileModalSlice";
import { linkFileModalAction } from "../../../../../global/link-file-modal/linkFileModalSlice";
// MUI Components:
import {
  Box,
  Typography,
  TextField,
  Fade,
  Button,
  useTheme,
  Divider,
  Switch,
  SvgIcon,
  Collapse,
} from "@mui/material";
import { useSnackbar } from "notistack";
// MUI Styles:
import { makeStyles } from "@mui/styles";
// SVG Icones:
import { ReactComponent as TrashIcon } from "../../../../../../assets/icons/trash-icon.svg";
import { drawer } from "../../drawerSlice";

// Type Controller
interface InputsState {
  name: string;
  description: string;
  isPassword: boolean;
  password: string;
  directDownloadFile: boolean;
  isNumberDownload: boolean;
  numberDownload: number;
  alternativeFile: {
    id: string;
    name: string;
  };
  changed: boolean;
}

const useStyles = makeStyles((theme) => ({
  collapseBox: {
    marginBottom: "6px",
  },
  field: {
    borderRadius: "5px",
    backgroundColor: "#F2F2F2",
    "& label.Mui-focused": {
      color: theme.palette.text.secondary,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#F2F2F2",
    },
    "& .MuiOutlinedInput-root": {
      paddingLeft: theme.spacing(0),
      "& fieldset": {
        borderColor: "#F2F2F2",
        borderRadius: "5px",
      },
      "&:hover fieldset": {
        borderColor: "#F2F2F2",
        borderWidth: 1.5,
      },
      "&.Mui-focused fieldset": {
        borderColor: "#F2F2F2",
        borderWidth: 1.5,
      },
    },
  },
  mySwitch: {
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(18px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#0FD672",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 20 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  },
  addressBox: {
    "&::-webkit-scrollbar": {
      borderRadius: "10px",
      width: "4px",
      height: "4px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(28, 33, 45, 0.4)",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      backgroundColor: theme.palette.secondary.main,
    },
  },
  fieldBox: {
    "&::-webkit-scrollbar": {
      borderRadius: "10px",
      width: "6px",
      height: "6px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(28, 33, 45, 0.4)",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

const DrawerShare = ({ itemInfo }: any) => {
  const { enqueueSnackbar } = useSnackbar();

  const classes = useStyles();
  const theme = useTheme();

  const dispatch = useAppDispatch();

  const { shareFile } = useAppSelector(drawerShare);
  const { selectedAlternativeFile } = useAppSelector(alternativeFileModal);
  const { openDrawer } = useAppSelector(drawer);

  const [inputs, setInputs] = useState<InputsState>({
    name: "",
    description: "",
    isPassword: false,
    password: "",
    directDownloadFile: false,
    isNumberDownload: false,
    numberDownload: 0,
    alternativeFile: {
      id: "",
      name: "",
    },
    changed: false,
  });
  const [openButton, setOpenButton] = useState(false);
  const [snackbarShow, setSnackbarShow] = useState(false);

  useEffect(() => {
    setInputs((last) => ({
      ...last,
      name: itemInfo.type
        ? itemInfo.name
            .split("")
            .reverse()
            .slice(
              itemInfo.name
                .split("")
                .reverse()
                .findIndex((item: string) => item === ".") + 1,
              itemInfo.name.split("").reverse().length
            )
            .reverse()
            .join("")
        : itemInfo.name,
    }));
  }, [itemInfo.name, itemInfo.type]);

  useEffect(() => {
    if (inputs.changed === true) {
      setOpenButton(true);
    } else {
      setOpenButton(false);
    }
  }, [inputs.changed]);

  useEffect(() => {
    if (
      inputs.name === "" ||
      // inputs.description === "" ||
      (inputs.isPassword === true && inputs.password === "")
    ) {
      setInputs((last) => ({ ...last, changed: false }));
    } else if (
      // (
      inputs.name !== "" ||
      //  &&
      //   inputs.name !==
      //     (itemInfo.type
      //       ? itemInfo.name
      //           .split("")
      //           .reverse()
      //           .slice(
      //             itemInfo.name
      //               .split("")
      //               .reverse()
      //               .findIndex((item: string) => item === ".") + 1,
      //             itemInfo.name.split("").reverse().length
      //           )
      //           .reverse()
      //           .join("")
      //       : itemInfo.name))
      inputs.description !== "" ||
      inputs.isPassword !== false ||
      inputs.password !== "" ||
      inputs.directDownloadFile !== false ||
      inputs.isNumberDownload !== false ||
      inputs.numberDownload !== 0 ||
      inputs.alternativeFile.name !== ""
    ) {
      setInputs((last) => ({ ...last, changed: true }));
    } else {
      setInputs((last) => ({ ...last, changed: false }));
    }
  }, [
    inputs.name,
    inputs.description,
    inputs.isPassword,
    inputs.password,
    inputs.directDownloadFile,
    inputs.isNumberDownload,
    inputs.numberDownload,
    inputs.alternativeFile,
    itemInfo.name,
    itemInfo.type,
  ]);

  useEffect(() => {
    if (inputs.isPassword) {
      setInputs((last) => ({
        ...last,
        password: last.password,
      }));
    } else {
      setInputs((last) => ({
        ...last,
        password: "",
      }));
    }
  }, [inputs.isPassword]);

  useEffect(() => {
    if (
      shareFile.actionStatus === "success" &&
      snackbarShow &&
      inputs.changed
    ) {
      setSnackbarShow(false);
      dispatch(deleteSelectedAlternativeFileAction());
      dispatch(resetShareFileStatusAction());
      setInputs({
        name: itemInfo.type
          ? itemInfo.name
              .split("")
              .reverse()
              .slice(
                itemInfo.name
                  .split("")
                  .reverse()
                  .findIndex((item: string) => item === ".") + 1,
                itemInfo.name.split("").reverse().length
              )
              .reverse()
              .join("")
          : itemInfo.name,
        description: "",
        isPassword: false,
        password: "",
        directDownloadFile: false,
        isNumberDownload: false,
        numberDownload: 0,
        alternativeFile: {
          id: "",
          name: "",
        },
        changed: false,
      });
      enqueueSnackbar("File sharing was done successfully.", {
        variant: "success",
      });
    }
  }, [
    dispatch,
    enqueueSnackbar,
    inputs.changed,
    itemInfo.name,
    itemInfo.type,
    shareFile.actionStatus,
    snackbarShow,
  ]);

  useEffect(() => {
    if (
      shareFile.alert.error &&
      shareFile.alert.message === "notMatch" &&
      inputs.changed
    ) {
      enqueueSnackbar("This name has already been used!", {
        variant: "error",
      });
    }
  }, [
    dispatch,
    enqueueSnackbar,
    inputs.changed,
    shareFile.alert.error,
    shareFile.alert.message,
  ]);

  useEffect(() => {
    setInputs((last) => ({
      ...last,
      alternativeFile: {
        id: selectedAlternativeFile.id,
        name: selectedAlternativeFile.name,
      },
    }));
  }, [selectedAlternativeFile]);

  return (
    <Box className={classes.collapseBox}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          margin: "0px 0px 8px 0px",
        }}
      >
        <Typography
          sx={{
            width: "calc(100% - 16px)",
            height: "24px",
            padding: "0px 0px 8px 0px",
            lineHeight: "1",
            fontSize: "1rem",
            opacity: "0.5",
            [theme.breakpoints.down("xl")]: {
              fontSize: "14px",
            },
            [theme.breakpoints.down("sm")]: {
              fontSize: "1rem",
            },
          }}
        >
          Name
        </Typography>

        <TextField
          name="name"
          type="text"
          value={inputs.name}
          onBlur={() =>
            openDrawer &&
            !inputs.name &&
            enqueueSnackbar("Please complete the name field!", {
              variant: "error",
            })
          }
          onChange={(e) =>
            setInputs((last) => ({
              ...last,
              name: e.target.value,
            }))
          }
          size={"small"}
          sx={{
            label: { color: (theme) => theme.palette.text.secondary },
            input: {
              padding: "10px 8px",
              fontSize: "14px",
              color: (theme) => theme.palette.text.secondary,
              "&::placeholder": {
                fontSize: "14px",
                color: (theme) => theme.palette.text.secondary,
              },
              "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #F2F2F2 inset",
                WebkitTextFillColor: (theme) => theme.palette.text.secondary,
                transition: " background-color 600000s 0s, color 600000s 0s",
              },
              [theme.breakpoints.down("xl")]: {
                fontSize: "12px",
              },
              [theme.breakpoints.down("sm")]: {
                fontSize: "14px",
              },
            },
            width: "100%",
          }}
          className={classes.field}
        />

        {/* <Typography
          sx={{
            width: "calc(100% - 16px)",
            padding: "8px 0px 4px",
            lineHeight: "1",
            fontSize: "12px",
            color: "#C5C5C5",
            overflowX: "auto",
            overflowY: "hidden",
            whiteSpace: "nowrap",
          }}
          className={classes.addressBox}
        >
          {`${window.location.host}/download/`}
          <span style={{ color: "#0086B9", opacity: "1" }}>{inputs.name}</span>
        </Typography> */}
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            width: "calc(100% - 16px)",
            height: "24px",
            padding: "0px 0px 8px 0px",
            lineHeight: "1",
            fontSize: "1rem",
            opacity: "0.5",
            [theme.breakpoints.down("xl")]: {
              fontSize: "14px",
            },
            [theme.breakpoints.down("sm")]: {
              fontSize: "1rem",
            },
          }}
        >
          Description
        </Typography>

        <TextField
          multiline
          rows={4}
          name="description"
          variant="filled"
          type="text"
          value={inputs.description}
          // onBlur={() =>
          //   !inputs.description &&
          //   enqueueSnackbar("Please complete the description field!", {
          //     variant: "error",
          //   })
          // }
          onChange={(e) => {
            setInputs((last) => ({
              ...last,
              description: e.target.value,
            }));
          }}
          size={"small"}
          sx={{
            "& .MuiInputBase-root": {
              borderRadius: "5px",
              backgroundColor: "#F2F2F2",
              padding: "10px 8px",
              fontSize: "14px",
              color: theme.palette.text.secondary,
              "&::placeholder": {
                fontSize: "14px",
                color: theme.palette.text.secondary,
              },
              "&:hover": {
                backgroundColor: "#F2F2F2",
              },
              [theme.breakpoints.down("xl")]: {
                fontSize: "12px",
              },
              [theme.breakpoints.down("sm")]: {
                fontSize: "14px",
              },
            },
            label: { color: (theme) => theme.palette.text.secondary },
            input: {
              color: (theme) => theme.palette.text.secondary,
              "&::placeholder": {
                fontSize: "14px",
                color: (theme) => theme.palette.text.secondary,
              },
              "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #F2F2F2 inset",
                WebkitTextFillColor: (theme) => theme.palette.text.secondary,
                transition: " background-color 600000s 0s, color 600000s 0s",
              },
            },
            width: "100%",
          }}
          InputProps={{
            disableUnderline: true,
          }}
        />
      </Box>

      <Divider sx={{ opacity: "0.2", mt: "8px", mb: "8px" }} />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "calc(100% - 16px)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              height: "24px",
              padding: "0px 0px 8px 0px",
              lineHeight: "1",
              fontSize: "1rem",
              opacity: "0.5",
              [theme.breakpoints.down("xl")]: {
                fontSize: "14px",
              },
              [theme.breakpoints.down("sm")]: {
                fontSize: "1rem",
              },
            }}
          >
            Password
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "0px 0px 8px",
            }}
          >
            <Typography
              sx={{
                lineHeight: "1",
                fontSize: "14px",
                opacity: "0.5",
                pr: "6px",
              }}
            >
              Off
            </Typography>

            <Switch
              checked={inputs.isPassword}
              onChange={(e) =>
                setInputs((last) => ({
                  ...last,
                  isPassword: e.target.checked,
                  directDownloadFile: e.target.checked
                    ? false
                    : last.directDownloadFile,
                }))
              }
              sx={{ width: 38, height: 20, padding: 0 }}
              className={classes.mySwitch}
            />

            <Typography
              sx={{
                lineHeight: "1",
                fontSize: "14px",
                opacity: "0.5",
                pl: "6px",
              }}
            >
              On
            </Typography>
          </Box>
        </Box>

        <Collapse in={inputs.isPassword} timeout={400} sx={{ width: "100%" }}>
          <TextField
            name="password"
            type="text"
            value={inputs.password}
            onBlur={() =>
              inputs.isPassword &&
              inputs.password === "" &&
              enqueueSnackbar("Please choose your file password!", {
                variant: "error",
              })
            }
            onChange={(e) =>
              setInputs((last) => ({
                ...last,
                password: e.target.value,
              }))
            }
            size={"small"}
            sx={{
              label: { color: (theme) => theme.palette.text.secondary },
              input: {
                padding: "10px 8px",
                fontSize: "14px",
                color: (theme) => theme.palette.text.secondary,
                "&::placeholder": {
                  fontSize: "14px",
                  color: (theme) => theme.palette.text.secondary,
                },
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #F2F2F2 inset",
                  WebkitTextFillColor: (theme) => theme.palette.text.secondary,
                  transition: " background-color 600000s 0s, color 600000s 0s",
                },
                [theme.breakpoints.down("xl")]: {
                  fontSize: "12px",
                },
                [theme.breakpoints.down("sm")]: {
                  fontSize: "14px",
                },
              },
              width: "100%",
            }}
            className={classes.field}
          />
        </Collapse>
      </Box>

      <Divider sx={{ opacity: "0.2", mt: "8px", mb: "8px" }} />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "calc(100% - 16px)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              height: "24px",
              padding: "0px 0px 8px 0px",
              lineHeight: "1",
              fontSize: "1rem",
              opacity: "0.5",
              [theme.breakpoints.down("xl")]: {
                fontSize: "14px",
              },
              [theme.breakpoints.down("sm")]: {
                fontSize: "1rem",
              },
            }}
          >
            Direct Download File
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "0px 0px 8px",
            }}
          >
            <Typography
              sx={{
                lineHeight: "1",
                fontSize: "14px",
                opacity: "0.5",
                pr: "6px",
              }}
            >
              Off
            </Typography>

            <Switch
              checked={inputs.directDownloadFile}
              onChange={(e) =>
                setInputs((last) => ({
                  ...last,
                  directDownloadFile: e.target.checked,
                  isPassword: e.target.checked ? false : last.isPassword,
                }))
              }
              sx={{ width: 38, height: 20, padding: 0 }}
              className={classes.mySwitch}
            />

            <Typography
              sx={{
                lineHeight: "1",
                fontSize: "14px",
                opacity: "0.5",
                pl: "6px",
              }}
            >
              On
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ opacity: "0.2", mt: "8px", mb: "8px" }} />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          margin: "0px 0px 8px 0px",
        }}
      >
        <Box
          sx={{
            width: "calc(100% - 16px)",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              width: "calc(100% - 16px)",
              height: "24px",
              padding: "0px 0px 8px 0px",
              lineHeight: "1",
              fontSize: "1rem",
              opacity: "0.5",
              [theme.breakpoints.down("xl")]: {
                fontSize: "14px",
              },
              [theme.breakpoints.down("sm")]: {
                fontSize: "1rem",
              },
            }}
          >
            Number
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "0px 0px 8px",
            }}
          >
            <Typography
              sx={{
                lineHeight: "1",
                fontSize: "14px",
                opacity: "0.5",
                pr: "6px",
              }}
            >
              Off
            </Typography>

            <Switch
              checked={inputs.isNumberDownload}
              onChange={(e) =>
                setInputs((last) => ({
                  ...last,
                  isNumberDownload: e.target.checked,
                  numberDownload: e.target.checked ? 1 : 0,
                }))
              }
              sx={{ width: 38, height: 20, padding: 0 }}
              className={classes.mySwitch}
            />

            <Typography
              sx={{
                lineHeight: "1",
                fontSize: "14px",
                opacity: "0.5",
                pl: "6px",
              }}
            >
              On
            </Typography>
          </Box>
        </Box>
        <Collapse
          in={inputs.isNumberDownload}
          timeout={400}
          sx={{ width: "100%" }}
        >
          <TextField
            name="numberDownload"
            type="number"
            value={inputs.numberDownload}
            onBlur={() =>
              inputs.isNumberDownload &&
              inputs.numberDownload === 0 &&
              enqueueSnackbar("Please choose your file number download!", {
                variant: "error",
              })
            }
            onChange={(e) =>
              setInputs((last) => ({
                ...last,
                numberDownload: +e.target.value < 1 ? 1 : +e.target.value,
              }))
            }
            size={"small"}
            sx={{
              label: { color: (theme) => theme.palette.text.secondary },
              input: {
                padding: "10px 8px",
                fontSize: "14px",
                color: (theme) => theme.palette.text.secondary,
                "&::placeholder": {
                  fontSize: "14px",
                  color: (theme) => theme.palette.text.secondary,
                },
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 1000px #F2F2F2 inset",
                  WebkitTextFillColor: (theme) => theme.palette.text.secondary,
                  transition: " background-color 600000s 0s, color 600000s 0s",
                },
                [theme.breakpoints.down("xl")]: {
                  fontSize: "12px",
                },
                [theme.breakpoints.down("sm")]: {
                  fontSize: "14px",
                },
              },
              width: "100%",
              margin: "0px 0px 8px 0px",
            }}
            className={classes.field}
          />

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                width: "calc(100% - 16px)",
                height: "24px",
                padding: "0px 0px 8px 0px",
                lineHeight: "1",
                fontSize: "1rem",
                opacity: "0.5",
                [theme.breakpoints.down("xl")]: {
                  fontSize: "14px",
                },
                [theme.breakpoints.down("sm")]: {
                  fontSize: "1rem",
                },
              }}
            >
              Alternative File
            </Typography>

            {!inputs.alternativeFile.name ? (
              <Typography
                sx={{
                  width: "calc(100% - 16px)",
                  height: "22px",
                  padding: "0px 0px 8px 0px",
                  lineHeight: "1",
                  fontSize: "1rem",
                  color: theme.palette.blue?.main,
                  opacity: "1",
                  cursor: "pointer",
                  [theme.breakpoints.down("xl")]: {
                    fontSize: "14px",
                  },
                  [theme.breakpoints.down("sm")]: {
                    fontSize: "1rem",
                  },
                }}
                onClick={(event) => dispatch(alternativeFileModalAction(true))}
              >
                Browse
              </Typography>
            ) : (
              <Box
                sx={{
                  width: "calc(100% - 16px)",
                  height: "22px",
                  padding: "0px 0px 8px 0px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    maxWidth: "75%",
                    height: "20px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    [theme.breakpoints.down("xl")]: {
                      height: "16px",
                      fontSize: "12px",
                    },
                    [theme.breakpoints.down("sm")]: {
                      fontSize: "14px",
                    },
                  }}
                >
                  {inputs.alternativeFile.name}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    dispatch(deleteSelectedAlternativeFileAction())
                  }
                >
                  <SvgIcon
                    component={TrashIcon}
                    inheritViewBox
                    sx={{
                      width: "16px",
                      height: "16px",
                      color: "#E36464",
                      mr: "4px",
                      [theme.breakpoints.down("xl")]: {
                        width: "14px",
                        height: "14px",
                      },
                      [theme.breakpoints.down("sm")]: {
                        width: "16px",
                        height: "14px",
                      },
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#E36464",
                      [theme.breakpoints.down("xl")]: {
                        fontSize: "12px",
                      },
                      [theme.breakpoints.down("sm")]: {
                        fontSize: "14px",
                      },
                    }}
                  >
                    Delete
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </Collapse>
      </Box>

      {openButton && (
        <Box
          sx={{
            width: "100%",
            height: openButton ? "fit-content" : "0px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: "8px",
          }}
        >
          <Fade in={openButton} timeout={500}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                color="tertiary"
                fullWidth
                type="submit"
                sx={{
                  width: "90px",
                  height: "40px",
                  fontSize: "18px",
                  borderRadius: "8px",
                  textTransform: "none",
                  lineHeight: "0px",
                  padding: "12px",
                  mr: "8px",
                  color: "inherit",
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  [theme.breakpoints.down("md")]: {
                    width: "calc(50% - 4px)",
                  },
                }}
                onClick={() => {
                  setInputs({
                    name: "",
                    description: "",
                    isPassword: false,
                    password: "",
                    directDownloadFile: false,
                    isNumberDownload: false,
                    numberDownload: 0,
                    alternativeFile: {
                      id: "",
                      name: "",
                    },
                    changed: false,
                  });
                  dispatch(deleteSelectedAlternativeFileAction());
                }}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                color="success"
                fullWidth
                type="submit"
                sx={{
                  width: "90px",
                  height: "40px",
                  fontSize: "18px",
                  borderRadius: "8px",
                  textTransform: "none",
                  lineHeight: "0px",
                  padding: "12px",
                  [theme.breakpoints.down("md")]: {
                    width: "calc(50% - 4px)",
                  },
                }}
                onClick={() => {
                  setSnackbarShow(true);
                  dispatch(shareFileAction(inputs));
                  dispatch(linkFileModalAction(true));
                }}
              >
                Add
              </Button>
            </Box>
          </Fade>
        </Box>
      )}
    </Box>
  );
};

export default DrawerShare;
